import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PimpinanLayout from "../../components/layout/PimpinanLayout";

// Import komponen icon yang divalidasi ada di library react-icons/fa
import { 
  FaThLarge, 
  FaCalendarCheck, 
  FaChartBar, 
  FaUserShield, 
  FaTimes 
} from "react-icons/fa";

export default function PetunjukPimpinan() {
  const [showModal, setShowModal] = useState(false);
  // State untuk melacak menu fitur mana yang sedang terbuka ke bawah (accordion)
  const [openFeature, setOpenFeature] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setShowModal(true);
  }, []);

  // Data petunjuk pimpinan yang dipisah per modul fungsi monitoring & evaluasi
  const petunjukFitur = [
    {
      nama: "Petunjuk Umum & Dashboard Monitoring",
      icon: <FaThLarge className="text-blue-500 text-base" />,
      langkah: [
        "Masuk ke sistem menggunakan kredensial akun Pimpinan yang telah terdaftar.",
        "Pantau grafik ringkasan kehadiran siswa secara makro pada halaman Dashboard utama.",
        "Gunakan menu navigasi sidebar di sebelah kiri untuk meninjau detail pengawasan operasional sekolah."
      ],
      infoTambahan: "Data dashboard diperbarui secara real-time berdasarkan aktivitas presensi guru dan siswa di lapangan."
    },
    {
      nama: "Pemantauan Jadwal Mengajar KBM",
      icon: <FaCalendarCheck className="text-orange-500 text-base" />,
      langkah: [
        "Buka menu Jadwal untuk meninjau distribusi jam pelajaran seluruh guru di sekolah.",
        "Pantau riwayat penunjukan 'Guru Pengganti' atau 'Pengambilan Jadwal Kosong' jika terdapat guru utama yang berhalangan hadir."
      ]
    },
    {
      nama: "Evaluasi Rekapitulasi & Laporan Presensi",
      icon: <FaChartBar className="text-green-500 text-base" />,
      langkah: [
        "Masuk ke menu Rekapitulasi data presensi siswa.",
        "Filter data berdasarkan periode harian, mingguan, atau bulanan sesuai kebutuhan evaluasi.",
        "Unduh berkas rekapitulasi kehadiran siswa sebagai dokumen penunjang kebijakan sekolah."
      ],
      infoTambahan: "Gunakan hasil unduhan rekapitulasi ini sebagai basis data utama dalam agenda rapat evaluasi berkala."
    },
    {
      nama: "Pengaturan Akun & Keamanan Kredensial",
      icon: <FaUserShield className="text-purple-500 text-base" />,
      langkah: [
        "Akses halaman Profil pimpinan melalui menu yang tersedia.",
        "Periksa validitas data akun Anda secara berkala.",
        "Lakukan pembaruan kata sandi (sandi akun) secara berkala demi menjaga keamanan hak akses monitoring."
      ]
    }
  ];

  // Fungsi untuk buka-tutup menu (Accordion)
  const toggleFeature = (index) => {
    setOpenFeature(openFeature === index ? null : index);
  };

  const handleClose = () => {
    setShowModal(false);
    navigate("/pimpinan");
  };

  return (
    <PimpinanLayout>
      <div className="p-4 sm:p-6">

        {showModal && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4">

            <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">

              {/* Header */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 border-b bg-blue-600 text-white flex justify-between items-center shrink-0">
                <h3 className="text-base sm:text-lg font-bold">
                  Petunjuk Penggunaan SIPENSA (Pimpinan)
                </h3>
                <button
                  onClick={handleClose}
                  className="p-1 rounded-lg hover:bg-blue-700 text-xl transition-colors flex items-center justify-center"
                >
                  <FaTimes />
                </button>
              </div>

              {/* Content / Accordion List */}
              <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-4 space-y-3">
                <p className="text-xs text-gray-500 font-medium mb-2">
                  Silakan pilih menu untuk melihat petunjuk monitoring sistem:
                </p>

                {petunjukFitur.map((fitur, idx) => {
                  const isOpen = openFeature === idx;
                  return (
                    <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50/50">

                      {/* Tombol Accordion */}
                      <button
                        onClick={() => toggleFeature(idx)}
                        className={`w-full px-4 py-3 flex justify-between items-center font-semibold text-sm transition-colors text-left ${
                          isOpen ? "bg-blue-50 text-blue-700" : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          {fitur.icon}
                          <span>{fitur.nama}</span>
                        </span>
                        
                        {/* Panah Indikator */}
                        <svg
                          className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? "rotate-180 text-blue-600" : "text-gray-400"}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {/* Isi Petunjuk Khusus Fitur Terpilih */}
                      {isOpen && (
                        <div className="p-4 bg-white border-t border-gray-100 space-y-3">
                          {fitur.langkah.map((isiLangkah, langkahIdx) => (
                            <div key={langkahIdx} className="flex gap-3 items-start">
                              {/* Nomor otomatis diulang dari 1 di tiap fitur */}
                              <span className="text-blue-600 font-bold text-sm min-w-[18px]">
                                {langkahIdx + 1}.
                              </span>
                              <span className="text-gray-600 text-sm leading-relaxed">
                                {isiLangkah}
                              </span>
                            </div>
                          ))}

                          {/* Info Tambahan Kondisional */}
                          {fitur.infoTambahan && (
                            <div className="mt-2 p-3 bg-yellow-50 border-l-4 border-yellow-400 text-xs text-gray-700 rounded-r">
                              {fitur.infoTambahan}
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  );
                })}
              </div>

              {/* Footer */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t flex justify-end shrink-0">
                <button
                  onClick={handleClose}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  Saya Mengerti
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </PimpinanLayout>
  );
}